// Create an order page
import React, { JSX } from 'react';
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

type Props = {
    showRewardNAWarningModal: boolean;
    onRewardNAWarningModalClose: () => void;
};
const RewardNAWarningModal: React.FC<Props> = (
    {
        showRewardNAWarningModal,
        onRewardNAWarningModalClose,
    },
):
    JSX.Element => {
    const {
        selectedReward,
    } = useSelector((state: RootState) => state.rewards);

    return (
        <Modal
            show={showRewardNAWarningModal}
            centered
            backdrop="static"
            style={{zIndex: "8888"}}
        >
            <Modal.Body className="font-sub">
                <span>
                    {/* eslint-disable-next-line react/no-unescaped-entities,max-len */}
                    We&lsquo;re sorry, the reward you&lsquo;ve chosen is not currently available at the selected location. Please choose another eligible reward or select another location.
                </span>
                <span className="d-none">
                    {selectedReward?.title}
                </span>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="order-now-card-button"
                    onClick={onRewardNAWarningModalClose}
                >
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RewardNAWarningModal;
